import React, { useContext } from 'react';
import { Checkbox, Grid } from 'vindi-ds-components';
import { FormContext } from '../hooks/useFormData';

function TermOfUseCheckbox() {
  const { useOfTerms, setUseOfTerms } = useContext(FormContext);
  const handleCheckboxChange = () => {
    setUseOfTerms(!useOfTerms);
  };

  return (
    <Grid container item xs={12} style={{ marginTop: '0px' }}>
      <Checkbox
        checked={useOfTerms}
        label='Concordo com os termos estabelecidos pelo Plano Now e com o limite do plano caso a conta atinja um volume superior a R$10mil processados por mês.'
        id='isCheckedId'
        data-testid='useOfTermsCheckbox'
        onChange={handleCheckboxChange}
      />
    </Grid>

  );
}
export default TermOfUseCheckbox;
